import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './languages/index.js'
import locale from 'element-ui/lib/locale'
import { getLanguage } from '@/utils/utils.js'
Vue.use(VueI18n)
let lang = getLanguage()
const i18n = new VueI18n({
  locale: lang,
  messages: messages
})
locale.i18n((key, value) => i18n.t(key, value))
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js